module.exports = __webpack_public_path__ + "6c6841eda5fba9ccde5945e0fc4f984c.png";